import { eTlfItemType } from "functions/api/enums";

export interface TocTlfItemFilterConfig {
  type: eTlfItemType;
  label: string;
  show: boolean;
}

/**
 * Available ToC TLF items
 */
export const TOC_TLF_ITEM_FILTER: TocTlfItemFilterConfig[] = [
  { type: eTlfItemType.arsTable, label: "ARS tables", show: true },
  { type: eTlfItemType.arsListing, label: "ARS listings", show: true },
  { type: eTlfItemType.figure, label: "Interactive figures", show: true },
  { type: eTlfItemType.table, label: "Tables", show: true },
  { type: eTlfItemType.listing, label: "Listings", show: true },
  { type: eTlfItemType.v1figure, label: "Legacy figures", show: true },
  { type: eTlfItemType.section, label: "Sections", show: true },
];

// Helper functions for localStorage
const TOC_TLF_ITEM_FILTER_STORAGE_KEY = "tocTlfItemFilter";

/**
 * Loads the TLF view mode configuration from localStorage.
 *
 * @returns The TLF view mode configuration loaded from localStorage, or the default if not found
 */
export const loadTocTlfItemFilterFromStorage = (): eTlfItemType[] => {
  const stored = localStorage.getItem(TOC_TLF_ITEM_FILTER_STORAGE_KEY);
  // Use stored as a filter if it exists
  if (stored) {
    const storedTypes = stored.split(",");
    return storedTypes as eTlfItemType[];
  }
  // Default to all shown
  return TOC_TLF_ITEM_FILTER.filter((i) => i.show).map((i) => i.type);
};

/**
 * Saves the TLF view mode configuration to localStorage.
 *
 * @param filter - The TLF view mode configuration to save to localStorage
 */
export const saveTocTlfItemFilterToStorage = (filter: eTlfItemType[]): void => {
  try {
    localStorage.setItem(TOC_TLF_ITEM_FILTER_STORAGE_KEY, filter.join(","));
  } catch {
    // Ignore localStorage errors
  }
};
